import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
var portalRoot = null;
import './GenerateTemporaryQrModal.scss';
import TemporaryTableQrRepository from '../../components/repository/TemporaryTableQrRepository';
import TemporaryTableQr from '../../Model/TemporaryTableQr';

const validTimes_Minute = [

]
const validTimes_Shortcut = [
    "15", "30",
    "46", "60",
    "75", "90",
    "105", "120",
]

const validTimes = [
    {
        id: 100,
        minute: 100,
    },
    {
        id: 2,
        minute: 30,
    },
    {
        id: 3,
        minute: 45,
    },
    {
        id: 4,
        minute: 60,
    },
    {
        id: 5,
        minute: 75,
    },
    {
        id: 6,
        minute: 90,
    },
    {
        id: 7,
        minute: 105,
    },
    {
        id: 8,
        minute: 120,
    },
    {
        id: 9,
        minute: 135,
    },
    {
        id: 10,
        minute: 150,
    },
    {
        id: 11,
        minute: 165,
    },
    {
        id: 12,
        minute: 180,
    },
]

const portalId = "generate-temporary-qr-modal-portal"
class GenerateTemporaryQrModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#'+portalId).length == 0) {
            $('body').prepend(`<div id="${portalId}" style="z-index: 1500"></div>`)
        }
        portalRoot = document.getElementById(portalId);
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class GenerateTemporaryQrModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            tempTableQrs: [],
            isDeactivating: false,
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);

        if (this.timer) {
            clearInterval(this.timer)
        }
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.onSave()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

        this.loadTemporaryTableQr();

    };

    calculateElapsedTime = (tempTableQrs) => {
        tempTableQrs.forEach(tempTableQr => {
            if (tempTableQr instanceof TemporaryTableQr) {
                tempTableQr.calculateElapsedTime()
            }
            else {
                const diffSecond = moment().diff(moment(tempTableQr.created_at), 'second')
                const hour = Math.floor(diffSecond / 3600)
                let minute = Math.floor((diffSecond % 3600) / 60)
                const second = diffSecond % 60
                let hourMinuteSecond = `${hour ? `${hour}:` : ""}${(minute+"").padStart("2", "0")}:${(second+"").padStart("2", "0")}`
                tempTableQr.elapsed = hourMinuteSecond
            }
        })
        return tempTableQrs
    }

    loadTemporaryTableQr = () => {
        TemporaryTableQrRepository.getInstance().getTemporaryQrForTable(this.props.tableId)
            .then(tempTableQrs => {
                this.setState({
                    tempTableQrs: this.calculateElapsedTime(tempTableQrs)
                }, () => {
                    if (this.timer) {
                        clearInterval(this.timer)
                    }
                    this.timer = setInterval(() => {
                        this.setState({
                            tempTableQrs: [...this.calculateElapsedTime(this.state.tempTableQrs)]
                        })
                    }, 1000)
                })
            })
    }
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    onReprintItemSelected = (tempQr) => {
        this.setState({
            selectedTime: null,
            customTime: "",
            selectedReprintTempQr: tempQr,
        })
    }
    onTimeSelected = (selectedTime) => {
        this.setState({
            selectedTime: selectedTime,
            customTime: "",
            selectedReprintTempQr: null,
        })
    }
    onCustomTimeChange = (e) => {
        const minute = parseInt(e.target.value) || 0
        let selectedTime = this.state.selectedTime
        let customTime = this.state.customTime
        let selectedReprintTempQr = this.state.selectedReprintTempQr
        if (minute || minute == 0) {
            customTime = minute
            selectedTime = null
            selectedReprintTempQr = null
        }
        this.setState({
            selectedTime, customTime, selectedReprintTempQr,
        })
    }

    onNo = () => {
        this.onNo && this.onNo()
    }

    onYes = () => {
        let minute = this.state.selectedTime || this.state.customTime || 0
        this.props.onYes && this.props.onYes(minute)
    }
    onReprintClicked = () => {
        this.props.onReprint && this.props.onReprint(this.state.selectedReprintTempQr.id)
    }
    onDeactivateClicked = () => {
        this.setState({
            isDeactivating: true,
        })
        TemporaryTableQrRepository.getInstance().deactivate(this.state.selectedReprintTempQr.id)
            .then((res) => {
                this.loadTemporaryTableQr()
                this.setState({
                    selectedReprintTempQr: null,
                })
            })
            .catch(err => {
                alert(err)
            })
            .finally(() => {
                this.setState({
                    isDeactivating: false,
                })
            })
    }

    customTimeInput = () => {
        return <div style={{display: "flex", maxWidth: "250px"}}>
            <span style={{flex: "1 0 100px"}}>
                <input type="text" className="form-control" value={this.state.customTime || ""} placeholder="Custom time, eg: 25" onChange={this.onCustomTimeChange} />
            </span>
            <span style={{margin: "auto", marginLeft: "5px"}}>
                {lang.minute}
            </span>
        </div>
    }

    render() {
        // const {  } = this.state
        const debugShowItemId = window.debugSetting && window.debugSetting.generate_temporary_table_qr && window.debugSetting.generate_temporary_table_qr.show_id
        return (
            <GenerateTemporaryQrModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="" style={{padding:"20px", marginTop: "30px", paddingTop: "10px", }}>
                        {
                            this.state.tempTableQrs.length > 0 &&
                            <div>
                                <div>
                                    {lang.reprint}
                                </div>
                                <TableFormatting
                                    debugShowId={debugShowItemId}
                                    numberingLeftToRight={true}
                                    columnCount={2}
                                    data={this.state.tempTableQrs}
                                    btnText={(item) => {
                                        return `${item.elapsed} / ${(item.duration+"")}:00`
                                    }}
                                    btnKey={(item) => {
                                        return item.id
                                    }}
                                    onItemSelected={(selectedItem) => {
                                        return this.onReprintItemSelected(selectedItem)
                                    }}
                                    isSelected={(item) => {
                                        return this.state.selectedReprintTempQr && this.state.selectedReprintTempQr.id == item.id
                                    }}
                                    />
                            </div>
                        }
                        <div>
                            <div>
                                {lang.valid_for}
                            </div>
                            <TableFormatting
                                numberingLeftToRight={true}
                                columnCount={4}
                                data={validTimes}
                                btnText={(item) => {
                                    return `${item.minute} ${lang.minute}`
                                }}
                                btnKey={(item) => {
                                    return item.id
                                }}
                                onItemSelected={(selectedItem) => {
                                    return this.onTimeSelected(selectedItem.minute)
                                }}
                                isSelected={(item) => {
                                    return this.state.selectedTime && this.state.selectedTime == item.minute
                                }}
                                extraTr={this.customTimeInput()} />
                        </div>
                    </div>
                    <div className="btm-pane" style={{display: "flex"}}>
                        {
                            !!this.state.selectedReprintTempQr &&
                            <div style={{flex: "0 0 100px",textAlign: "left"}}>
                                <button disabled={!this.state.selectedReprintTempQr || this.state.isDeactivating} className="btn btn-danger" onClick={this.onDeactivateClicked}>{lang.deactivate} {this.state.isDeactivating && <i className="fa fa-spinner fa-spin"/>}</button>
                            </div>
                        }

                        <div style={{flex: "1 0 100px",textAlign: "right"}}>
                            <button disabled={!(this.state.selectedReprintTempQr)} className="btn btn-primary mr-1" onClick={this.onReprintClicked}>{lang.reprint}</button>
                            <button disabled={!(this.state.customTime || this.state.selectedTime)} className="btn btn-primary" onClick={this.onYes}>{lang.print_new_qr}</button>
                        </div>
                    </div>
                </Modal>
            </GenerateTemporaryQrModalPortal>
        )
    }
}

class TableFormatting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            columnCount: this.getColumnCount()
        }
    }
    onTimeSelected = (selectedTime) => {
        this.props.onTimeSelected(selectedTime)
    }
    getColumnCount = () => {
        // Here we can set how many columns we want to arrange the options
        return this.props.columnCount
    }
    getRows = () => {
        const { data, } = this.props
        let columnCount = this.state.columnCount
        let rowCount = this.props.data.length / columnCount
        let rows = []
        for (let row = 0; row < rowCount; row++) {
            let tds = []
            for (let col = 0; col < columnCount; col++) {
                // Default is top to bottom
                let rowOffset = row
                let colOffset = col * rowCount
                if (this.props.numberingLeftToRight) {
                    rowOffset = row * columnCount
                    colOffset = col
                }
                let index = rowOffset + colOffset
                let item = data[index]
                if (!item) {
                    // Last row/column might not able to fully filled
                    continue
                }
                const isSelected = this.props.isSelected(item)
                tds.push(<td key={this.props.btnKey(item)} style={{backgroundColor: item.color || "inherit"}}>
                    <button className={`btn ${isSelected ? "btn-primary active" : "btn-default"}`} style={{width: "100%"}} onClick={() => this.props.onItemSelected(item)}>
                        <span>{this.props.btnText(item)} {(this.props.debugShowId && item.id) && `(ID:${item.id})` || ""}</span>
                    </button>
                </td>)
            }
            rows.push(<tr key={row}>
                {tds}
            </tr>)
        }
        return rows
    }
    render() {

        return (
            <div style={{textAlign: "center"}}>
                <table style={{marginLeft: "auto", marginRight: "auto"}} className="generate-temporary-qr-select-time-table">
                    <tbody>
                        {this.getRows()}
                        {
                            this.props.extraTr &&
                            <tr>
                                <td colSpan={this.state.columnCount}>
                                    {this.props.extraTr}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}
GenerateTemporaryQrModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default GenerateTemporaryQrModal;